export default __webpack_public_path__ + "static/media/photo 15.ed4e21b4.jpg";